import { useSportContext } from '#src/contexts/sport/index.ts';

import { useFeatureFlags } from './useFeatureFlags.tsx';

export const useQuickplayAssets = () => {
  const { sport } = useSportContext();
  const {
    flags: { useQuickplayAssetsPerSport = {} },
  } = useFeatureFlags();

  return useQuickplayAssetsPerSport[sport];
};
